import React from 'react';
import StandardColumns from './StandardColumns';
import SortableNameDescriptionColumns from './SortableNameDescriptionColumns';
import StaticNameDescriptionColumns from './StaticNameDescriptionColumns';

const NameDescriptionColumns = ({
  category,
  className,
  children,
  columns = [],
  entity,
  items,
  onCheckBoxClick,
  onOrderByColumn,
  orderBy,
  singleSorting,
  toolsWidth,
}) => (
  <StandardColumns
    entity={entity}
    className={className}
    onCheckBoxClick={onCheckBoxClick}
    items={items}
    columns={columns}
    toolsWidth={toolsWidth}
  >
    {onOrderByColumn && (
    <SortableNameDescriptionColumns
      orderBy={orderBy}
      singleSorting={singleSorting}
      category={category}
      columns={columns}
      onOrderByColumn={onOrderByColumn}
    />
    )}
    {!onOrderByColumn && (<StaticNameDescriptionColumns columns={columns} />)}
    {children}
  </StandardColumns>
);

export default NameDescriptionColumns;
